<mf-row>
  <mf-field-select
    [label]="gridFilter.header"
    [(ngModel)]="value"
    [enumName]="gridFilter.enumName ?? ''"
    [enumNameModule]="gridFilter.enumNameModule"></mf-field-select>
</mf-row>
